import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';

import constants from '../../../_consts';
import loadingConstants from '../../loading-constants';
import {buildOptions, getEndPoint, showApiCallbackErrorMessage} from '../../../utils/api-call';
import {makeCall} from '../../../utils/request';
import {streamXlsxFileWithBlob} from '../../../utils/streamFile';
import state from './states';
import iziToastOptions from '../../../utils/izi-toast';

const _ = require('lodash');

Vue.use(VueAxios, axios);

const actions = {
  ACTION_SUBMIT_EVENT: ({dispatch, commit}, item) => {
    let apiStr = getEndPoint().events.updateEvent;
    item.lastModifiedBy = localStorage.getItem(constants.LOCAL_STORE.userId);
    Vue.axios.post(apiStr, item).then(response => {
      commit('MUTATION_DELETE_EVENT_AT_LOCAL', item.id);
      dispatch('ACTION_GET_EVENT_COUNT');
      commit('MUTATION_DELETE_EVENT_AT_LOCAL_MANAGE_TAB', item.id);
      Vue.prototype.$toastr('info', 'Submit event successful', '');
    }).catch(function (ex) {
      console.log(ex);
      showApiCallbackErrorMessage(ex);
    });
  },
  ACTION_GET_EVENT_COUNT_BY_CLIENT: ({commit}, clientIds) => {
    if (_.isEmpty(clientIds)) {
      return;
    }
    let apiStr = getEndPoint().events.countEvents;
    Vue.axios.get(apiStr, {
      params: {
        userId: localStorage.getItem(constants.LOCAL_STORE.userId),
        clientIdList: clientIds.join(','),
        isTotal: true
      }
    }).then((response) => {
      if (!response.data || response.data.message !== null) {
        console.log('get count by clientId error:', (response.data && response.data.message) || '');
        return;
      }
      let resCounters = response.data.countTotalEventsByClient || [];
      commit('MUTATION_CLEAR_COUNT_CLIENT');
      resCounters.forEach((item) => {
        let counter = {};
        counter.clientId = item.clientId;
        counter.countTotalEventsByStatus = item.countEventsByStatus;
        commit('MUTATION_SET_COUNT_CLIENT', counter);
      });
    });
  },
  ACTION_GET_EVENT_COUNT: ({commit}, countTotal = false) => {
    let clientIdList = localStorage.getItem(constants.LOCAL_STORE.clientId);
    if (countTotal) {
      clientIdList = 0;
    }
    let apiStr = getEndPoint().events.countEvents;
    Vue.axios.get(apiStr, {
      params: {
        userId: localStorage.getItem(constants.LOCAL_STORE.userId),
        clientIdList: clientIdList,
        isTotal: false
      }
    }).then((response) => {
      if (!response.data) return;
      if (response.data.message !== null) {
        console.log('request error:', response.data.message);
      } else {
        state.countTotalEvent = [];
        let countTotalEvent = response.data.countTotalEventsByClient[0].countEventsByStatus || [];
        for (let countItem of countTotalEvent) {
          commit('MUTATION_SET_COUNT_TOTAL', countItem);
        }
      }
    });
  },
  ACTION_GET_EVENT_LIST: ({dispatch, commit, state}, params) => {
    state.listEvent = [];
    state.isLoading = true;
    let apiStr = getEndPoint().events.getEvents;
    return Vue.axios.get(apiStr, {
      params: {
        userId: params.userId || localStorage.getItem(constants.LOCAL_STORE.userId),
        status: params.status.join() || '',
        clientId: params.clientId || localStorage.getItem(constants.LOCAL_STORE.clientId),
        currentPage: parseInt(params.options.currentPage) || 1,
        itemsPerPage: 1000, // (params.options.itemsPerPage === 'SHOW ALL') ? 10000 : (parseInt(params.options.itemsPerPage) || 10),
        sortType: params.options.sortType || 'isChangeOrder',
        sortReverse: params.options.sortReverse || false,
        programId: params.programId
      }
    }).then((response) => {
      state.isLoading = false;
      if (!response.data) return;
      if (response.data.message !== null) {
        console.log('request error:', response.data.message);
        Vue.prototype.$toastr('error', response.data.message, '');
      } else {
        if (response.data.events === null) {
          response.data.events = [];
        }
        response.data.events.forEach((element, index) => {
          element.timeStartModel = element.startTime;
          element.contact = element.contactName ? {
            contactName: element.contactName,
            contactEmail: '',
            contactPhone: ''
          } : [];
          element.showCollapse = state.expandId === element.id;
          element.lastModifiedAt *= 1000;
          element.durationBackup = element.duration;
          element.shippingAddressBackup = element.shippingAddress;
          element.eventNameBackup = element.eventName;
          element.isSuggestChanges = false;

          // listEvent.forEach((element, index) => {
          element['additionalServices'] = _.cloneDeep(constants.addOns);
          element.disableDuration = false;
          let strAddOns = localStorage.getItem(constants.LOCAL_STORE.addOns);
          let arrAddOns = strAddOns.split(',');
          let arrOnOff = element.addOns === null ? [] : element.addOns.split(',');
          let fields = constants.fields;
          element['additionalServices'].forEach(service => {
            // show / hide
            arrAddOns.forEach(ele => {
              if (ele === service.key) {
                service.isShow = true;
                if (ele === constants.listAdditionalServicesKey.smallSiteModel) {
                  service.isShow = parseInt(element[fields.event.projPart]) < 34;
                }
                // Used to check if small Site Concierge based on small Site Model
                if (ele === constants.listAdditionalServicesKey.smallSiteConcierge) {
                  service.isShow = strAddOns.indexOf('smallSiteModel') >= 0 && arrOnOff.indexOf('smallSiteModel') >= 0 && parseInt(element[fields.event.projPart]) < 34;
                }
              }
            });
            // on / off
            arrOnOff.forEach(ele => {
              if (ele === service.key) {
                service.value = true;
              }
            })
          });
          // });
        }, this);
      }
      commit('MUTATION_SET_EVENT_LIST', response.data.events);
      if (state.flagCreateEvent === true && params.status.join().toLowerCase() === constants.eventStatus.drafts) {
        dispatch('ACTION_CREATE_NEW_EVENT');
      }
      // dispatch('ACTION_GET_EVENT_COUNT');
    });
  },
  ACTION_SET_EXPAND_ID: ({commit, state}, expandObj) => {
    commit('MUTATION_SET_EXPAND_ID', expandObj.isExpand ? expandObj.id : (expandObj.id === state.expandId ? -1 : expandObj.id));
  },
  setUserId: ({commit}, id) => {
    commit('setUserId', id);
  },
  ACTION_CREATE_NEW_EVENT: ({commit, state}) => {
    let newEvent = _.cloneDeep(constants.initEvent);
    newEvent.clientId = localStorage.getItem(constants.LOCAL_STORE.clientId);
    newEvent.createdBy = localStorage.getItem(constants.LOCAL_STORE.userId);
    newEvent.lastModifiedByUserName = localStorage.getItem(constants.LOCAL_STORE.userName);
    newEvent.clientName = localStorage.getItem(constants.LOCAL_STORE.clientName);
    state.currentEvent = newEvent;
    // Vue.prototype.$toastr('info', 'Create new event successful', '');
  },
  ACTION_UPDATE_EVENT: ({dispatch, commit, state}, eventItem) => {
    state.isUpdating = true;
    state.indexOfItemModifying = eventItem.index;
    let model = {
      ...eventItem,
      id: parseInt(eventItem.id),
      lastModifiedBy: parseInt(localStorage.getItem(constants.LOCAL_STORE.userId)),
      clientId: parseInt(eventItem.clientId)
    };
    return dispatch('ACTION_REQUEST_UPDATE_EVENT', model).then(response => {
      if (state.messageError === '') {
        if (!eventItem.id) eventItem.id = response.data.event.id;
        eventItem.shippingAddress = response.data.event.shippingAddress;
        Vue.prototype.$toastr('info', 'Update event successful', '');
      }
    });
  },
  ACTION_DUPLICATE_EVENT: async ({dispatch, commit}, {item, status = null, isAddToList = true}) => {
    let newEvent = Object.assign({}, item);
    newEvent.id = 0;
    newEvent.index = 0;
    newEvent.status = status || item.status;
    return dispatch('ACTION_REQUEST_UPDATE_EVENT', newEvent).then(response => {
      if (isAddToList) {
        commit('MUTATION_CREATE_NEW_EVENT', response.data.event);
      }

      if (state.messageError === '') {
        Vue.prototype.$toastr('info', 'Duplicate event successful', '');
      }
    });
  },
  ACTION_REQUEST_UPDATE_EVENT: async ({dispatch, commit, state}, item, successMessage) => {
    let eventItem = _.cloneDeep(item);
    if (item.index >= 0 && item.index < state.listEvent.length) {
      state.indexOfItemModifying = item.index;
    }
    let apiStr = getEndPoint().events.updateEvent;
    return new Promise((resolve, reject) => {
      axios
        .post(apiStr, eventItem)
        .then(response => {
          let eventId = (response.data && response.data.event.id) || 0;
          if (response.data.statusCode === 'CREATED') {
            commit('MUTATION_SET_EVENT_LIST_CREATE', response.data && response.data.event);
          }

          if (state.indexOfItemModifying >= 0 && state.listEvent.length > 0 && state.listEvent[state.indexOfItemModifying].id === 0) {
            commit('MUTATION_UPDATE_EVENT_ID', eventId);
          }
          if (response.data.event.status === 'APPROVED') {
            dispatch('ACTION_GET_EVENT_DETAIL_HISTORY', eventId);
          }
          commit('MUTATION_UPDATE_EVENT', response.data && response.data.event ? Object.assign(response.data.event, {contact: item.contact}) : null);
          commit('MUTATION_UPDATE_EVENT_IN_LIST', response.data && response.data.event ? response.data.event : null);
          // dispatch('ACTION_GET_EVENT_LIST', JSON.parse(localStorage.getItem(constants.LOCAL_STORE.pagingOptions)));
          dispatch('ACTION_GET_EVENT_COUNT');
          commit('MUTATION_SET_MESSAGE_ERROR', (response.data && response.data.message) || '');
          state.isUpdating = false;
          resolve(response);
        })
        .catch(function (ex) {
          state.isUpdating = false;
          let errorMessage = (ex.response && ex.response.data && ex.response.data.message) || 'Internal server error.';
          commit('MUTATION_SET_MESSAGE_ERROR', errorMessage);
          showApiCallbackErrorMessage(ex);
          reject(ex);
        });
    });
  },
  ACTION_APPROVE_EVENT: async ({dispatch, commit}, event) => {
    let eventItem = _.cloneDeep(event);
    eventItem.status = constants.eventStatus.approved.toUpperCase();
    eventItem.lastModifiedBy = localStorage.getItem(constants.LOCAL_STORE.userId);
    await dispatch('ACTION_REQUEST_UPDATE_EVENT', eventItem).then(() => {
      if (state.showRelatedEvents === true) {
        commit('MUTATION_SET_LIST_BACK');
      }
      commit('MUTATION_DELETE_EVENT_AT_LOCAL', eventItem.id);
      dispatch('ACTION_GET_EVENT_COUNT');
      // dispatch('ACTION_GET_EVENT_LIST', JSON.parse(localStorage.getItem(constants.LOCAL_STORE.pagingOptions)));
    });
    if (state.messageError === '') {
      Vue.prototype.$toastr('info', 'Approve event successful', '');
    }
  },
  ACTION_EXPORT_TO_EXCEL: () => {
    // call Api
    let clientId = Number(localStorage.getItem(constants.LOCAL_STORE.clientId));
    if (clientId !== 0) {
      let apiUrl = getEndPoint().events.exportExcel + '/?clientId=' + clientId + '&userId=' + localStorage.getItem(constants.LOCAL_STORE.userId);
      window.open(apiUrl);
    } else {
      Vue.prototype.$toastr('info', 'Please select client before exporting.', '');
    }
  },
  ACTION_SET_LIST_EVENT_STATUS: ({commit}, eventStatus) => {
    commit('MUTATION_SET_LIST_EVENT_STATUS', eventStatus);
  },
  ACTION_SUGGEST_CHANGES: async ({dispatch, commit, state}, eventItem) => {
    eventItem.status = constants.eventStatus.review.toUpperCase();
    eventItem.lastModifiedBy = localStorage.getItem(constants.LOCAL_STORE.userId);
    eventItem.lastModifiedAt = new Date().getTime();
    await dispatch('ACTION_REQUEST_UPDATE_EVENT', eventItem);
    if (state.showRelatedEvents === true) {
      commit('MUTATION_SET_LIST_BACK');
    }
    commit('MUTATION_DELETE_EVENT_AT_LOCAL', eventItem.id);
    if (state.messageError === '') {
      Vue.prototype.$toastr('info', 'Suggest change event successful', '');
    }
  },
  ACTION_SET_ITEM_RELATED: ({commit}, eventItem) => {
    // get item related info
    let apiUrl = getEndPoint().events.getRelatedItemInfo;
    Vue.axios.get(apiUrl, {
      params: {
        eventId: eventItem.id,
        userId: localStorage.getItem(constants.LOCAL_STORE.userId)
      }
    }).then(response => {
      commit('MUTATION_SET_ITEM_RELATED', {
        item: eventItem,
        relatedInfo: response.data.countTotalEventsByStatus
      });
    }).catch(function (response) {
      console.log(response);
    });
  },
  ACTION_SET_LIST_BACK: ({commit}) => {
    commit('MUTATION_SET_LIST_BACK');
  },
  ACTION_GET_EVENT_RELATED: ({commit}, params) => {
    let apiUrl = getEndPoint().events.getEventsRelated;
    if (params.status.length === 0) {
      commit('MUTATION_SET_EVENTS_RELATED', []);
      return;
    }
    Vue.axios.get(apiUrl, {
      params: {
        eventId: params.eventId,
        status: params.status.join(),
        currentPage: parseInt(params.options.currentPage),
        itemsPerPage: parseInt(params.options.itemsPerPage),
        sortType: params.options.sortType,
        sortReverse: params.options.sortReverse,
        userId: localStorage.getItem(constants.LOCAL_STORE.userId)
      }
    }).then(response => {
      commit('MUTATION_SET_EVENTS_RELATED', response.data.events);
    }).catch(function (response) {
      console.log(response);
    })
  },
  ACTION_DELETE_EVENT: ({dispatch, commit}, eventItem) => {
    let apiUrl = getEndPoint().events.deleteEvent;
    return Vue.axios.get(apiUrl, {
      params: {
        eventId: eventItem.id,
        userId: localStorage.getItem(constants.LOCAL_STORE.userId)
      }
    }).then(response => {
      commit('MUTATION_DELETE_EVENT_AT_LOCAL', eventItem.id);
      dispatch('ACTION_GET_EVENT_LIST', JSON.parse(localStorage.getItem(constants.LOCAL_STORE.pagingOptions)));
      dispatch('ACTION_GET_EVENT_COUNT');
      Vue.prototype.$toastr('info', 'Delete event successful', '');
    }).catch(function (response) {
      console.log(response);
      Vue.prototype.$toastr('info', (response.data && response.data.message) || '', '');
    });
  },
  ACTION_SUBMIT_EVENTS: ({dispatch, commit}, { clientId, eventIds }) => {
    let apiUrl = getEndPoint().events.submitEvents;
    let params = {
      clientId: clientId,
      eventIds: eventIds
    };
    return axios.get(apiUrl, {params: params}).then(response => {
      if (response.data.eventList !== null && response.data.eventList.length > 0) {
        response.data.eventList.forEach(e => {
          let index = eventIds.indexOf(e.id);
          eventIds.splice(index, 1);

          Vue.prototype.$toast.error('Unable to submit event \'' + e.eventName + '\'. Please review and try again.', '', {
            ...iziToastOptions.optError
          });
        })
      }

      commit('MUTATION_DELETE_EVENTS', eventIds);
    }).catch(function (response) {
      console.log(response);
    })
  },
  ACTION_SUBMIT_ALL_EVENT: ({dispatch, commit}) => {
    let apiUrl = getEndPoint().events.submitAllEvent;
    let params = {
      userId: Number(localStorage.getItem(constants.LOCAL_STORE.userId)),
      clientId: Number(localStorage.getItem(constants.LOCAL_STORE.clientId))
    };
    return axios.get(apiUrl, {params: params}).then(response => {
      if (response.data.eventList !== null && response.data.eventList.length > 0) {
        response.data.eventList.forEach((e) => {
          Vue.prototype.$toast.error('Unable to submit event \'' + e.eventName + '\'. Please review and try again.', '', {
            ...iziToastOptions.optError
          });
        }, this);

        commit('MUTATION_SET_EVENT_LIST', response.data.eventList);
        commit('MUTATION_SET_ERROR_CODE', response.data.errorCodes)
        // state.submitAllEventSuccess = false;
        // commit('MUTATION_SET_MESSAGE_ERROR', response.data.message || '')
      } else {
        commit('MUTATION_SET_EVENT_LIST', []);
        // show modal submit all event success
      }
      dispatch('ACTION_GET_EVENT_COUNT');
    }).catch(function (response) {
      console.log(response);
    })
  },
  ACTION_RESTORE_LIST_EVENT: ({commit}) => {
    commit('MUTATION_RESTORE_LIST_EVENT');
  },
  ACTION_SET_SHOW_RELATED_EVENT: ({commit}, showRelated) => {
    commit('MUTATION_SET_SHOW_RELATED_EVENT', showRelated);
  },
  ACTION_RESET_EXPAND_ID: ({commit}) => {
    commit('MUTATION_RESET_EXPAND_ID');
  },
  ACTION_SAVE_COLUMN_WIDTH: ({commit, state}, resizeObj) => {
    let isTableUser = resizeObj.isTableUser;
    let colName = isTableUser ? 'firstName' : 'eventName';
    let el = document.getElementById(colName);
    let elWidth = el.getBoundingClientRect().width;
    let column = isTableUser ? state.columnTableUserWidth[colName] : state.columnWidth[colName];
    let next = column.next;
    let width = 0;
    do {
      if (colName === resizeObj.colName) {
        elWidth = parseFloat(resizeObj.newWidth);
      } else {
        elWidth = parseFloat(el.getBoundingClientRect().width.toFixed(2));
      }
      commit('MUTATION_SAVE_COLUMN_WIDTH', {colName: colName, newSize: elWidth, isTableUser: isTableUser});
      width = parseFloat(width) + elWidth;

      colName = column.next;
      el = document.getElementById(colName);
      column = isTableUser ? state.columnTableUserWidth[colName] : state.columnWidth[colName];
      next = column.next;
    }
    while (next);

    // save action column width
    if (el) {
      elWidth = parseFloat(el.getBoundingClientRect().width.toFixed(2));
      commit('MUTATION_SAVE_COLUMN_WIDTH', {colName: colName, newSize: elWidth, isTableUser: isTableUser});
      width = parseFloat(width) + elWidth;
    }
    let tbHeaderId = 'dt-header';
    let tbBodyId = 'dt-body';
    let dtHeaderEl = document.getElementById(tbHeaderId);
    let dtBodyEl = document.getElementById(tbBodyId);
    dtHeaderEl.style.width = resizeObj.newHeaderWidth + 'px';
    if (dtBodyEl) {
      dtBodyEl.style.width = resizeObj.newHeaderWidth + 'px';
    }
  },
  ACTION_SAVE_COLUMN_STAFFING_WIDTH: ({commit, state}, resizeObj) => {
    let colName = 'firstName';
    let el = document.getElementById(colName);
    let elWidth = el.getBoundingClientRect().width;
    let column = state.columnTableStaffingWidth[colName];
    let next = column.next;
    let width = 0;
    do {
      if (colName === resizeObj.colName) {
        elWidth = parseFloat(resizeObj.newWidth);
      } else {
        elWidth = parseFloat(el.getBoundingClientRect().width.toFixed(2));
      }
      commit('MUTATION_SAVE_COLUMN_STAFFING_WIDTH', {colName: colName, newSize: elWidth});
      width = parseFloat(width) + elWidth;

      colName = column.next;
      el = document.getElementById(colName);
      column = state.columnTableStaffingWidth[colName];
      next = column.next;
    }
    while (next);

    // save action column width
    elWidth = parseFloat(el.getBoundingClientRect().width.toFixed(2));
    commit('MUTATION_SAVE_COLUMN_STAFFING_WIDTH', {colName: colName, newSize: elWidth});
    width = parseFloat(width) + elWidth;
    let tbHeaderId = 'dt-header';
    let tbBodyId = 'dt-body';
    let dtHeaderEl = document.getElementById(tbHeaderId);
    let dtBodyEl = document.getElementById(tbBodyId);
    dtHeaderEl.style.width = resizeObj.newHeaderWidth + 'px';
    dtBodyEl.style.width = resizeObj.newHeaderWidth + 'px';
  },
  ACTION_GET_LIST_ON_SITE_CONTACT: async ({commit}, keyword) => {
    if (keyword === null || keyword === '') {
      commit('MUTATION_SET_LIST_ON_SITE_CONTACT', []);
      return;
    }
    let apiUrl = getEndPoint().events.getOnSiteContact;
    await Vue.axios.get(apiUrl, {
      params: {
        keyword: keyword,
        clientId: localStorage.getItem(constants.LOCAL_STORE.clientId),
        userId: localStorage.getItem(constants.LOCAL_STORE.userId)
      }
    }).then((response) => {
      if (response.data.contacts !== null) {
        response.data.contacts.forEach((element) => {
          element.contactNameDecoration = element.contactName.toLowerCase().replace(keyword, '<b>' + keyword + '</b>');
        });
        commit('MUTATION_SET_LIST_ON_SITE_CONTACT', response.data.contacts);
      } else {
        commit('MUTATION_SET_LIST_ON_SITE_CONTACT', []);
      }
    }).catch(function (response) {
      console.log(response);
    })
  },
  CREATE_EVENT_FLAG: async ({commit}, isCreate) => {
    await commit('MUTATION_CREATE_EVENT_FLAG', isCreate)
  },
  ACTION_RESET_COLUMN_SIZE: ({commit}) => {
    let colName = 'eventName';
    let column = state.columnWidth[colName];
    let next = column.next;

    do {
      commit('MUTATION_RESET_COLUMN_SIZE', colName);

      colName = column.next;
      column = state.columnWidth[colName];
      next = column.next;
    }
    while (next);
    commit('MUTATION_RESET_COLUMN_SIZE', colName);
  },
  ACTION_REMOVE_LOCK_EVENTS: async () => {
    let userId = localStorage.getItem(constants.LOCAL_STORE.userId);
    let apiUrl = getEndPoint().events.removeEventLockList;
    await Vue.axios.get(apiUrl, {
      params: {
        userId: userId
      }
    }).then((response) => {
    });
  },
  ACTION_LOCK_EVENT_LIST: async ({state}) => {
    let apiUrl = getEndPoint().events.getEventLockList;
    await Vue.axios.get(apiUrl).then((response) => {
      console.log('Locked events: ', response.data);
      state.lockIds.eventIds = response.data.eventIds !== null ? response.data.eventIds : [];
      state.lockIds.userIds = response.data.userIds !== null ? response.data.userIds : [];
    });
  },
  ACTION_LOCK_EVENT: ({state}, lockObj) => {
    let index = state.lockIds.eventIds.indexOf(lockObj.eventId);
    if (index === -1 && lockObj.isLocked) {
      state.lockIds.eventIds.push(lockObj.eventId);
      state.lockIds.userIds.push(lockObj.userId);
    }
    if (index !== -1 && !lockObj.isLocked && state.lockIds.userIds[index] === lockObj.userId.toString()) {
      state.lockIds.eventIds.splice(index, 1);
      state.lockIds.userIds.splice(index, 1);
    }
    console.log(index, lockObj.isLocked, state.lockIds.userIds[index], lockObj.userId.toString(), state.lockIds.userIds[index] === lockObj.userId.toString());
  },
  ACTION_SET_SUBMIT_ALL_EVENT_SUCCESS: ({commit, state}, submitAllEventSuccess) => {
    state.submitAllEventSuccess = submitAllEventSuccess;
  },
  ACTION_RESTART_LIST_EVENT_STATUS: ({state}, listStatus) => {
    state.listEventStatus = listStatus;
  },
  ACTION_SET_MESSAGE_ERROR: ({state, commit}, message) => {
    commit('MUTATION_SET_MESSAGE_ERROR', message)
  },
  ACTION_GET_EVENT_HISTORY: async ({state, commit}, eventId) => {
    let apiUrl = getEndPoint().events.getEventHistory;
    await Vue.axios.get(apiUrl, {
      params: {
        eventId: eventId
      }
    }).then((response) => {
      if (response.status !== 200 || response.data.message) {
        console.log('error:', response);
      }
      commit('MUTATION_SET_EVENT_HISTORY', response.data.events);
    });
  },
  ACTION_GET_EVENT_DETAIL_HISTORY: ({state, commit}, eventId) => {
    let apiUrl = getEndPoint().events.getEventHistory;
    commit('MUTATION_SET_IS_LOADING_EVENT_HISTORY', true);
    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptions('GET', {
        params: {
          eventId
        }
      })).then(response => {
        commit('MUTATION_SET_EVENT_DETAIL_HISTORY', response);
        resolve(response);
      }, error => {
        reject(error);
      }).finally(() => {
        commit('MUTATION_SET_IS_LOADING_EVENT_HISTORY', false);
      });
    })
  },
  ACTION_UPDATE_EVENT_ADD_ON: async ({state, commit}, obj) => {
    let apiUrl = getEndPoint().events.updateAddOn;
    return new Promise((resolve, reject) => {
      axios.post(apiUrl, obj).then(response => {
        commit('MUTATION_UPDATE_ADDON', {obj: obj, addOns: response.data.addOns});
        resolve(response);
      }).catch(function (response) {
        Vue.prototype.$toastr('error', 'Update event unsuccessful');
        reject(response);
      });
    });
  },
  ACTION_CHANGE_EVENT_STATUS: async ({dispatch, state, commit}, obj) => {
    let apiUrl = getEndPoint().events.changeEventStatus;
    await Vue.axios.post(apiUrl, obj).then(response => {
      if (response.status !== 200 || response.data.message) {
        Vue.prototype.$toastr('error', 'Update event unsuccessful');
      } else {
        commit('MUTATION_DELETE_EVENT_AT_LOCAL', obj.eventId);
        dispatch('ACTION_GET_EVENT_COUNT');
        Vue.prototype.$toastr('info', 'Update event successful', '');
      }
    }).catch(function (response) {
      console.log('error:', response);
      Vue.prototype.$toastr('error', 'Update event unsuccessful');
    });
  },
  ACTION_GET_EVENTS_BY_DATES: ({commit, state}, obj) => {
    let apiUrl = getEndPoint().events.getEventsByDates;
    // set limit begin dates
    let numberLimitBegin = obj.noBeginDates;
    let numberLimitEnd = obj.noEndDates === '60+' ? 100 : obj.noEndDates;

    state.keywordSearchEvent = obj.keyword;
    let body = {
      noBeginDates: numberLimitBegin,
      noEndDates: numberLimitEnd, // 100 is represent for 60+, can be any number which is bigger than 60
      selectedDate: obj.selectedDate,
      clientId: obj.clientId,
      keyword: obj.keyword,
      currentPage: obj.currentPage || 1,
      itemsPerPage: obj.itemsPerPage === null || obj.itemsPerPage === undefined ? 25 : obj.itemsPerPage,
      sortType: obj.sortType || 'dateTime',
      eventStatusRequest: (obj.eventStatus && obj.eventStatus.toUpperCase()) || 'ALL',
      eventStatus: [obj.status || 'APPROVED'],
      requireReport: obj.requireReport || null
    };
    return new Promise((resolve, reject) => {
      state.isLoading = true;
      makeCall(apiUrl, buildOptions('POST', body)).then(response => {
        state.isLoading = false;
        if (response.approvedEvents === null) {
          response.approvedEvents = [];
        }
        response.approvedEvents.forEach((elementParent, index) => {
          elementParent.events.forEach((element, index) => {
            element.timeStartModel = element.startTime;
            element.contact = {
              contactName: element.contactName,
              contactEmail: '',
              contactPhone: ''
            };
            element.showCollapse = state.expandId === element.id;
            element.lastModifiedAt *= 1000;
            element.durationBackup = element.duration;
            element.shippingAddressBackup = element.shippingAddress;
            element.eventNameBackup = element.eventName;
            element.isSuggestChanges = false;

            // listEvent.forEach((element, index) => {
            element['additionalServices'] = _.cloneDeep(constants.addOns);
            element.disableDuration = false;
            let strAddOns = localStorage.getItem(constants.LOCAL_STORE.addOns);
            let arrAddOns = strAddOns.split(',');
            let arrOnOff = element.addOns === null ? [] : element.addOns.split(',');
            let fields = constants.fields;
            element['additionalServices'].forEach(service => {
              // show / hide
              arrAddOns.forEach(ele => {
                if (ele === service.key) {
                  service.isShow = true;
                  if (ele === constants.listAdditionalServicesKey.smallSiteModel) {
                    service.isShow = parseInt(element[fields.event.projPart]) < 34;
                  }
                  // Used to check if small Site Concierge based on small Site Model
                  if (ele === constants.listAdditionalServicesKey.smallSiteConcierge) {
                    service.isShow = strAddOns.indexOf('smallSiteModel') >= 0 && arrOnOff.indexOf('smallSiteModel') >= 0 && parseInt(element[fields.event.projPart]) < 34;
                  }
                }
              });
              // on / off
              arrOnOff.forEach(ele => {
                if (ele === service.key) {
                  service.value = true;
                }
              })
            });
          }, this);
        }, this);
        commit('MUTATION_SET_APPROVED_EVENTS', {
          ...response,
          changeFilter: obj.changeFilter,
          currentPage: obj.currentPage
        });
        commit('MUTATION_SEARCH_APPROVED_EVENT', state.keywordSearchEvent);
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  },
  ACTION_GET_DATE_HAS_DATA: ({commit, state}, selectedDate) => {
    let apiUrl = getEndPoint().events.getDateHasData;
    Vue.axios.get(apiUrl, {
      params: {
        selectedDate: selectedDate
      }
    }).then((response) => {
      if (response.status !== 200 || response.data.message) {
        console.log('error:', response);
      }
      commit('MUTATION_SET_DATE_HAS_DATA', response.data.daysHasData || []);
    }).catch(function (response) {
      console.log(response);
    })
  },
  ACTION_LOCKED_DATE: ({commit, state}) => {
    let apiUrl = getEndPoint().events.getLockedDate;
    Vue.axios.get(apiUrl).then((response) => {
      if (response.status !== 200 || response.data.message) {
        console.log('error:', response);
      }
      commit('MUTATION_SET_LOCKED_DATE', response.data.dates || []);
    }).catch(function (response) {
      console.log(response);
    })
  },
  ACTION_GET_DATE_RANGE_HAS_DATA: ({commit, state}, dateRange) => {
    let apiUrl = getEndPoint().events.getDateRangeHasData;
    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptions('GET', {
        params: {
          startDate: dateRange.startDate,
          endDate: dateRange.endDate
        }
      })).then(response => {
        resolve(response);
        commit('MUTATION_SET_DATE_RANGE_HAS_DATA', response.datesHasData || []);
      })
    })
  },
  ACTION_GET_EVENT_BY_ID: ({state}, eventId) => {
    let apiUrl = getEndPoint().events.getEventById;
    let id = eventId || state.eventDetailId;
    return new Promise((resolve, reject) => {
      state.isLoadingModal = true;
      makeCall(apiUrl, buildOptions('GET', {params: {eventId: id}})).then(response => {
        state.isLoadingModal = false;
        state.isLoading = false; // set it to false when finish loading event detail
        state.eventDetailId = id;
        let element = response.event;
        element.timeStartModel = element.startTime;
        element.contact = {
          contactName: element.contactName,
          contactEmail: '',
          contactPhone: ''
        };
        element.showCollapse = state.expandId === element.id;
        element.lastModifiedAt *= 1000;
        element.durationBackup = element.duration;
        element.shippingAddressBackup = element.shippingAddress;
        element.eventNameBackup = element.eventName;
        element.isSuggestChanges = false;
        element['additionalServices'] = _.cloneDeep(constants.addOns);
        element.disableDuration = false;
        let strAddOns = localStorage.getItem(constants.LOCAL_STORE.addOns);
        let arrAddOns = strAddOns.split(',');
        let arrOnOff = element.addOns === null ? [] : element.addOns.split(',');
        let fields = constants.fields;
        element['additionalServices'].forEach(service => {
          // show / hide
          arrAddOns.forEach(ele => {
            if (ele === service.key) {
              service.isShow = true;
              if (ele === constants.listAdditionalServicesKey.smallSiteModel) {
                service.isShow = parseInt(element[fields.event.projPart]) < 34;
              }
              // Used to check if small Site Concierge based on small Site Model
              if (ele === constants.listAdditionalServicesKey.smallSiteConcierge) {
                service.isShow = strAddOns.indexOf('smallSiteModel') >= 0 && arrOnOff.indexOf('smallSiteModel') >= 0 && parseInt(element[fields.event.projPart]) < 34;
              }
            }
          });
          // on / off
          arrOnOff.forEach(ele => {
            if (ele === service.key) {
              service.value = true;
            }
          })
        });
        state.eventDetailChangeOrder = element;
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  },
  ACTION_GET_EVENT_STAFFING: ({state}, eventId) => {
    let apiUrl = getEndPoint().events.getEventStaffing;
    return new Promise((resolve, reject) => {
      // state.isLoadingModal = true;
      makeCall(apiUrl, buildOptions('GET', {params: {eventId: eventId || state.eventDetailId}})).then(response => {
        // state.isLoadingModal = false;
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  },
  ACTION_BLOCK_DATE: ({commit, state}, selectedDate) => {
    let apiUrl = getEndPoint().events.blockDate;
    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptions('POST', selectedDate)).then(response => {
        commit('MUTATION_SET_LOCKED_DATE', response.dates || []);
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  },
  ACTION_OPEN_DATE: ({commit, state}, selectedDate) => {
    let apiUrl = getEndPoint().events.openDate;
    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptions('POST', selectedDate)).then(response => {
        commit('MUTATION_SET_LOCKED_DATE', response.dates || []);
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  },
  ACTION_BLOCK_OR_OPEN_ALL_SLOTS: ({state}, obj) => {
    let apiUrl = getEndPoint().events.blockOrOpenSlots;
    let body = {
      eventId: obj.eventId,
      duration: obj.duration,
      blocked: obj.blocked
    };
    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptions('POST', body)).then(response => {
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  },
  ACTION_CHANGE_DURATION: ({state}, obj) => {
    let apiUrl = getEndPoint().events.changeDuration;
    let body = {
      eventId: obj.eventId || state.eventDetailId,
      duration: obj.duration,
      blocked: null
    };
    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptions('POST', body)).then(response => {
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  },
  ACTION_BLOCK_OPEN_STAFFING: ({state}, staffingArr) => {
    let apiUrl = getEndPoint().events.updateEventStaffing;
    let body = {
      eventSlot: staffingArr
    };
    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptions('POST', body)).then(response => {
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  },
  ACTION_CLEAR_SLOT: ({state}, slot) => {
    let apiUrl = getEndPoint().events.clearSingleSlot;
    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptions('POST', slot)).then(response => {
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  },
  ACTION_GET_TRACKING_STATUS: ({state}, obj) => {
    let apiUrl = getEndPoint().events.getTrackingStatus + '/' + obj.eventId + '/' + obj.trackingNumber;
    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptions('GET')).then(response => {
        console.log('get tracking status res:', response);
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  },
  ACTION_GET_EVENT_COUNT_BY_CLIENT_NEW: ({state}, { clientId, programId }) => {
    let apiUrl = getEndPoint().events.countEvents;
    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptions('GET', {
        params: {
          userId: localStorage.getItem(constants.LOCAL_STORE.userId),
          clientIdList: clientId,
          isTotal: true,
          programId
        }
      })).then(response => {
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  },
  ACTION_GET_EVENT_BY_STATUS: ({state}, obj) => {
    let apiUrl = getEndPoint().events.getEventByStatus;
    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptions('GET', {
        params: {
          clientId: obj.clientId,
          status: obj.status
        }
      })).then(response => {
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  },
  ACTION_GET_URL_FOR_PACKING_SLIP: ({state}) => {
    let apiUrl = getEndPoint().events.getURLForPackingSlip;
    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptions('GET', {})).then(response => {
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  },
  ACTION_DOWNLOAD_PACKING_SLIP: ({state}, token) => {
    let apiUrl = getEndPoint().events.getPackingSlip + '/?token=' + token;
    window.open(apiUrl);
  },
  ACTION_GET_STAFF_LIST: ({state}, obj) => {
    let apiUrl = getEndPoint().clients.getStaffLIst;
    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptions('GET',
        {
          params: {
            keyword: obj.keyword || '',
            currentPage: obj.currentPage || 1,
            itemsPerPage: obj.itemsPerPage || 25,
            sortType: obj.sortType || 'firstName',
            sortReverse: obj.sortReverse || false
          }
        }
      )).then(response => {
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  },
  ACTION_CREATE_STAFF: ({state}, staff) => {
    let apiUrl = getEndPoint().clients.updateStaff;
    let body = staff;
    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptions('POST', body)).then(response => {
        if (!response.message) {
          Vue.prototype.$toastr('info', 'Save staff successfully', '');
        }
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  },
  ACTION_DELETE_STAFF: ({state}, staff) => {
    let apiUrl = getEndPoint().clients.deleteStaff;
    let body = staff;
    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptions('POST', body)).then(response => {
        if (!response.message) {
          Vue.prototype.$toastr('info', 'Delete staff successfully', '');
        }
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  },
  ACTION_ADD_STAFF_SLOT: ({state}, data) => {
    let apiStr = getEndPoint().events.getStaffMaxSlots;
    return new Promise((resolve, reject) => {
      makeCall(apiStr, buildOptions('POST', data)).then(response => {
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  },
  ACTION_GET_ALL_AVAILABLE_STAFFS: ({state}, obj) => {
    let apiUrl = getEndPoint().events.getAllAvailableStaffs;
    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptions('GET',
        {
          params: {
            eventId: obj.eventId || 0,
            role: obj.role || '',
            searchString: obj.searchString || ''
          }
        }
      )).then(response => {
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  },
  ACTION_ASSIGN_STAFF: ({state}, data) => {
    let apiStr = getEndPoint().events.assignStaff;
    return new Promise((resolve, reject) => {
      makeCall(apiStr, buildOptions('POST', data)).then(response => {
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  },
  ACTION_GET_EVENT_STAFF: ({dispatch, commit}, eventId) => {
    let apiUrl = getEndPoint().events.getEventStaff;
    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptions('GET',
        {
          params: {
            eventId: eventId || 0
          }
        }
      )).then(response => {
        if (!response.message) {
          commit('MUTATION_SAVE_EVENT_STAFF', {listType: 'staffLead', data: response.staffLead || []});
          commit('MUTATION_SAVE_EVENT_STAFF', {listType: 'staffScreener', data: response.staffScreener || []});
          commit('MUTATION_SAVE_EVENT_STAFF', {listType: 'staffConcierge', data: response.staffConcierge || []});
        }
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  },
  ACTION_GET_EVENT_REPORT_CHART: ({dispatch, commit}, data) => {
    let apiUrl = getEndPoint().events.getEventReportChart;
    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptions('GET',
        {
          params: {
            eventId: data.eventId || 0,
            status: (data.reportType || 'upcoming').toUpperCase()
          }
        }
      )).then(response => {
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  },
  ACTION_UPDATE_IS_LIVE_EVENT: ({dispatch, commit}, obj) => {
    let apiUrl = getEndPoint().events.updateIsLiveEvent;
    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptions('POST', obj)).then(response => {
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  },
  ACTION_SEARCH_RELATED_EVENTS: ({state}, obj) => {
    let apiUrl = getEndPoint().events.searchRelatedEvents;
    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptions('GET', {
        params: {
          eventId: obj.eventId || 0,
          searchString: obj.searchString || ''
        }
      }
      )).then(response => {
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  },
  ACTION_ADD_REMOVE_RELATED_EVENTS: ({state}, obj) => {
    let apiUrl = getEndPoint().events.addOrRemoveRelatedEvents;
    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptions('POST', obj)).then(response => {
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  },
  ACTION_GET_DEFAULT_EMAIL_TEMPLATE: ({ state }, obj) => {
    let apiUrl = getEndPoint().events.getDefaultEmailTemplate;
    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptions('GET', {
        params: {
          eventId: obj.eventId || 0,
          singleEvent: obj.isSingleEvent
        }
      }
      )).then(response => {
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  },
  ACTION_SEND_ON_SITE_CONTACT_EMAIL: ({state}, obj) => {
    let apiUrl = getEndPoint().events.sendOnSiteContactEmail;
    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptions('POST', obj)).then(response => {
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  },
  ACTION_GET_EVENT_HISTORIES_BY_ID: ({ state }, params) => {
    let apiUrl = getEndPoint().events.getEventHistoriesById;
    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptions('GET', params)).then(response => {
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  },
  ACTION_GET_EMAIL_HISTORY_DETAILS: ({ state }, id) => {
    let apiUrl = getEndPoint().events.getEmailHistoryDetails;
    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptions('GET', {
        params: {
          historyId: id
        }
      })).then(response => {
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  },
  ACTION_ADD_PARTICIPANT: ({state}, obj) => {
    let apiUrl = getEndPoint().events.addParticipant;
    if (obj.isUpdating) {
      apiUrl = getEndPoint().events.updateParticipant;
    }
    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptions('POST', obj)).then(response => {
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  },
  UPDATE_MAX_NUMBER_FLU_SHOT: ({state}, obj) => {
    let apiUrl = getEndPoint().events.updateMaxNumberSlotFluShot;
    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptions('POST', obj)).then(response => {
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  },
  ACTION_SEARCH_PARTICIPANT: ({state, commit}, params) => {
    state.isLoadingParticipant = loadingConstants.LOADING;
    let apiUrl = getEndPoint().events.searchParticipant;
    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptions('GET', params))
        .then(response => {
          state.isLoadingParticipant = loadingConstants.LOADED;
          resolve(response);
        })
        .catch(error => {
          state.isLoadingParticipant = loadingConstants.INIT;
          reject(error);
        });
    });
  },
  ACTION_GENERATE_PACKING_SLIP: ({state}, param) => {
    let apiStr = getEndPoint().events.generatePackingSlip;
    Vue.axios.get(apiStr, {
      params: {
        eventId: param
      },
      responseType: 'blob'
    }).then(response => {
      const date = new Date();
      // eslint-disable-next-line
      const month = `0${date.getMonth()+1}`.slice(-2);
      const filename = `PackingSlip_${month}_${date.getFullYear()}`;
      // download file
      streamXlsxFileWithBlob(response.data, filename);
    }).catch(error => {
      console.log(error);
    });
  },
  ACTION_RESEND_BIO_SURVEY: ({state, commit}, params) => {
    return new Promise((resolve, reject) => {
      makeCall(getEndPoint().events.resendBiometricSurvey, buildOptions('POST', params))
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  ACTION_CANCEL_ALL_APPOINTMENTS: ({state}, eventId) => {
    return new Promise((resolve, reject) => {
      makeCall(getEndPoint().events.cancelAllAppointments, buildOptions('POST', eventId))
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    })
  },
  ACTION_GET_EVENTS_DATES: ({state}, params) => {
    return new Promise((resolve, reject) => {
      makeCall(getEndPoint().events.getEventsByDates, buildOptions('POST', params))
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    })
  },
  ACTION_DOWNLOAD_BULK_EVENTS_TEMPLATE: () => {
    let apiUrl = getEndPoint().events.bulkCreateEventTemplate;
    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptions('GET', {})).then(response => {
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  },
  ACTION_UPLOAD_FILE_BULK_CREATE_EVENTS: ({state}, params) => {
    return new Promise((resolve, reject) => {
      makeCall(getEndPoint().events.uploadBulkCreateEvent, buildOptions('POST', params))
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    })
  },
  ACTION_GET_UPLOAD_HISTORIES: ({state}, params) => {
    return new Promise((resolve, reject) => {
      makeCall(getEndPoint().events.uploadHistories + `?currentPage=${params.currentPage}&itemsPerPage=${params.itemsPerPage}&clientId=${params.clientId}`, buildOptions('GET')).then(response => {
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  },
  ACTION_DOWNLOAD_UPLOADED_FILE: ({state}, params) => {
    return new Promise((resolve, reject) => {
      makeCall(getEndPoint().events.downloadUploadedFile + `?fileId=${params.fileId}&clientId=${params.clientId}`, buildOptions('GET')).then(response => {
        resolve(response);
      }, error => {
        reject(error);
      });
    });
  },
  ACTION_UPDATE_NEXT_ZINDEX: ({state}, elementId) => {
    let element = document.getElementById(elementId);
    if (!element) return;
    element.style.zIndex = (++state.zIndex);
  },
  ACTION_EXPORT_PARTICIPANT_REPORT: ({dispatch, state, commit}, programId) => {
    if (!programId) programId = 0;
    let clientId = Number(localStorage.getItem(constants.LOCAL_STORE.clientId));
    if (clientId !== 0) {
      commit('MUTATION_SET_IS_DOWNLOADING', true);
      let apiUrl = getEndPoint().events.exportParticipantReport + '/?clientId=' + clientId + '&programId=' + programId;
      return new Promise((resolve, reject) => {
        makeCall(apiUrl, buildOptions('GET'))
          .then((response) => {
            const anchor = document.createElement('a');
            anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(response);
            anchor.target = '_blank';
            anchor.download = 'ParticipantReport.csv';
            anchor.click();
            resolve();
          }).catch((err) => {
            Vue.prototype.$toastr('error', 'Can not download CSV file!', '');
            reject(err);
          }).finally(() => {
            commit('MUTATION_SET_IS_DOWNLOADING', false);
          })
      });
    } else {
      Vue.prototype.$toastr('info', 'Please select client before exporting.', '');
    }
  },
  ACTION_UPDATE_EVENT_SHIFTBOARD: ({dispatch, state, commit}, params) => {
    let apiUrl = getEndPoint().events.updateEventShiftboard.replace('{eventId}', params.eventId);
    let body = { workgroupId: params.workgroupId, role: params.role };
    state.isLoadingModal = true;
    return new Promise((resolve, reject) => {
      makeCall(apiUrl, buildOptions('POST', body)).then(response => {
        resolve(response);
        Vue.prototype.$toastr('info', 'Save event shiftboard successfully', '');
        state.isLoadingModal = false;
      }).catch((err) => {
        Vue.prototype.$toastr('error', 'Can not save event shiftboard', '');
        reject(err);
        state.isLoadingModal = false;
      })
    });
  }
};

export default actions



// WEBPACK FOOTER //
// ./src/store/modules/events/actions.js